/* global isTouchDevice:false */
/* global closest:false */
/* global isCSSTransitionSupported:false */
/* global globalMethods:false */

(function() {

	if (isTouchDevice) {
		var dropdownMenuItems = document.querySelectorAll('.js-toggle-menu-dropdown-link');

		Array.prototype.forEach.call(dropdownMenuItems, function(item) {
			item.addEventListener('click', function(e) {
				e.preventDefault();
				e.stopPropagation();

				return false;
			});
		});
	}

	var size = undefined;

	var detectScrollbarSize = function (recalc) {
		if ((!size && size !== 0) || recalc) {
			var scrollDiv = document.createElement('div')

			scrollDiv.style.position = 'absolute'
			scrollDiv.style.top = '-9999px'
			scrollDiv.style.width = '50px'
			scrollDiv.style.height = '50px'
			scrollDiv.style.overflow = 'scroll'

			document.body.appendChild(scrollDiv)
			size = scrollDiv.offsetWidth - scrollDiv.clientWidth
			document.body.removeChild(scrollDiv)
		}

		return size
	}

	var offNavBreakpoint = 640;

	var OffCanvas = function(element) {
		this.active = false; // state of offcanvas navigation
		this.element = element;
		this.triggers = document.querySelectorAll('[aria-controls="' + this.element.getAttribute('id') + '"]');
		this.selectedTrigger = false;
		this.animating = false;
		this.firstFocusable = null;
		this.lastFocusable = null;
		var panel = this;

		if (window.innerWidth < offNavBreakpoint && !panel.active) {
			panel = initOffCanvas(panel);
		}

		window.addEventListener('resize', function() {
			if (window.innerWidth < offNavBreakpoint && !panel.active) {
				panel = initOffCanvas(panel);
			}

			if (window.innerWidth >= offNavBreakpoint) {
				panel = destroyOffCanvas(panel);
			}
		});
	};

	var onClickHandler = function(panel, event) {
		panel.selectedTrigger = event.currentTarget;
		event.preventDefault();
		togglePanel(panel);
	};

	var blockedClickHandler = function(event) {
		event.preventDefault();

		return false;
	};

	function initCollapsibleItems() {
		var collapsibleNavigations = document.querySelectorAll('.js-collapsible-nav');

		for (var i = 0 ; i < collapsibleNavigations.length; i++) {
			var navigation = collapsibleNavigations[i];

			var button = navigation.querySelector('.js-collapsible-nav-button');
			button.setAttribute('tabindex', '-1');
			button.addEventListener('click', blockedClickHandler);
			button.innerHTML = '<button aria-expanded="false">' + button.textContent + '</button>';
			button.firstChild.addEventListener('click', function(event) {
				event.preventDefault();
				event.stopPropagation();

				var isExpanded = this.getAttribute('aria-expanded') === 'true' || false;

				this.setAttribute('aria-expanded', !isExpanded);
				this.parentNode.parentNode.querySelector('.js-collapsible-nav-content').hidden = isExpanded;
				this.parentNode.classList.toggle('expanded');
			});

			navigation.querySelector('.js-collapsible-nav-content').setAttribute('hidden', 'hidden');
		}
	}

	function destroyCollapsibleItems() {
		var collapsibleNavigations = document.querySelectorAll('.js-collapsible-nav');

		for (var i = 0 ; i < collapsibleNavigations.length; i++) {
			var navigation = collapsibleNavigations[i];

			var button = navigation.querySelector('.js-collapsible-nav-button');
			button.removeAttribute('tabindex');
			button.removeEventListener('click', blockedClickHandler);
			if (button.firstChild !== undefined) {
				button.innerHTML = '<span>' + button.firstChild.textContent + '</span>';
			}

			navigation.querySelector('.js-collapsible-nav-content').removeAttribute('hidden');
		}
	}

	function initOffCanvas(panel) {
		panel.element.setAttribute('aria-hidden', 'true');
		panel.element.setAttribute('tabindex', '-1');

		// lister to the click on off-canvas content triggers
		for (var i = 0 ; i < panel.triggers.length; i++) {
			panel.triggers[i].addEventListener('click', onClickHandler.bind(null, panel))
		}

		panel.active = true;

		initCollapsibleItems();

		return panel;
	};

	function destroyOffCanvas(panel) {
		panel.element.setAttribute('aria-hidden', 'false');
		panel.element.removeAttribute('tabindex');

		document.body.style.overflow = 'initial';
		document.body.style.touchAction = 'initial';
		document.body.style.paddingRight = '0px';

		// lister to the click on off-canvas content triggers
		for (var i = 0 ; i < panel.triggers.length; i++) {
			panel.triggers[i].removeEventListener('click', onClickHandler.bind(null, panel));
		}

		panel.active = false;

		destroyCollapsibleItems();

		return panel;
	}

	function togglePanel(panel) {
		var status = panel.element.getAttribute('aria-hidden') == 'true' ? 'close' : 'open';

		if (status == 'close') {
			openPanel(panel);
		} else {
			closePanel(panel);
		}
	};

	function openPanel(panel) {
		// already animating
		if (panel.animating) {
			return;
		}

		panel.animating = true;
		panel.element.setAttribute('aria-hidden', 'false');
		panel.element.classList.add('navigation-layout--visible');
		getFocusableElements(panel);

		document.body.style.overflow = 'hidden';
		document.body.style.touchAction = 'none';
		document.body.style.paddingRight = detectScrollbarSize() + 'px';

		var transitionEl = panel.element;

		transitionEl.addEventListener('transitionend', function cb() {
			// wait for the end of transition to move focus and update the animating property
			panel.animating = false;
			panel.element.focus();
			transitionEl.removeEventListener('transitionend', cb);
		});

		if (!isCSSTransitionSupported) {
			panel.animating = false;
		}

		initPanelEvents(panel);
	};

	function closePanel(panel) {
		// already animating
		if (panel.animating) {
			return;
		}

		panel.animating = true;
		panel.element.setAttribute('aria-hidden', 'true');
		panel.element.classList.remove('navigation-layout--visible');

		document.body.style.overflow = 'initial';
		document.body.style.touchAction = 'initial';
		document.body.style.paddingRight = '0px';

		var transitionEl = panel.element;

		transitionEl.addEventListener('transitionend', function cb() {
			panel.animating = false;

			if (panel.selectedTrigger) {
				panel.selectedTrigger.focus();
			}

			setTimeout(function() {
				panel.selectedTrigger = false;
			}, 10);

			transitionEl.removeEventListener('transitionend', cb);
		});

		if (!isCSSTransitionSupported) {
			panel.animating = false;
		}

		cancelPanelEvents(panel);
	};

	function initPanelEvents(panel) {
		panel.element.addEventListener('keydown', handleEvent.bind(panel));
		panel.element.addEventListener('click', handleEvent.bind(panel));
	};

	function cancelPanelEvents(panel) {
		panel.element.removeEventListener('keydown', handleEvent.bind(panel));
		panel.element.removeEventListener('click', handleEvent.bind(panel));
	};

	function handleEvent(event) {
		switch(event.type) {
			case 'keydown':
				initKeyDown(this, event);
				break;
			case 'click':
				initClick(this, event);
				break;
		}
	};

	function initClick(panel, event) {
		// close panel when clicking on close button
		if (!closest(event.target, '.js-off-canvas-close-btn')) {
			return;
		}

		event.preventDefault();
		closePanel(panel);
	};

	function initKeyDown(panel, event) {
		if (event.keyCode && event.keyCode == 27 || event.key && event.key == 'Escape') {
			//close off-canvas panel on esc
			closePanel(panel);
		} else if (event.keyCode && event.keyCode == 9 || event.key && event.key == 'Tab') {
			//trap focus inside panel
			trapFocus(panel, event);
		}
	};

	function trapFocus(panel, event) {
		if (panel.firstFocusable == document.activeElement && event.shiftKey) {
			// on Shift+Tab -> focus last focusable element when focus moves out of panel
			event.preventDefault();
			panel.lastFocusable.focus();
		}
		if (panel.lastFocusable == document.activeElement && !event.shiftKey) {
			//on Tab -> focus first focusable element when focus moves out of panel
			event.preventDefault();
			panel.firstFocusable.focus();
		}
	};

	function getFocusableElements(panel) {
		// get all focusable elements inside the off-canvas content
		var allFocusable = panel.element.querySelectorAll('[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, [tabindex]:not([tabindex="-1"]), [contenteditable], audio[controls], video[controls], summary');
		getFirstVisible(panel, allFocusable);
		getLastVisible(panel, allFocusable);
	};

	function getFirstVisible(panel, elements) {
		// get first visible focusable element inside the off-canvas content
		for (var i = 0; i < elements.length; i++) {
			if (elements[i].offsetWidth || elements[i].offsetHeight || elements[i].getClientRects().length) {
				panel.firstFocusable = elements[i];
				return true;
			}
		}
	};

	function getLastVisible(panel, elements) {
		// get last visible focusable element inside the off-canvas content
		for (var i = elements.length - 1; i >= 0; i--) {
			if (elements[i].offsetWidth || elements[i].offsetHeight || elements[i].getClientRects().length) {
				panel.lastFocusable = elements[i];
				return true;
			}
		}
	};

	//initialize the off-canvas objects
	var offCanvas = document.getElementsByClassName('js-off-canvas-panel');

	if (offCanvas.length > 0) {
		for (var i = 0; i < offCanvas.length; i++) {
			(function(i) {
				new OffCanvas(offCanvas[i]);
			})(i);
		}
	}

}());
